const TileThemes = {
  Default: "default",
  Dark: "dark",
  Warning: "warning",
} as const;

export type TileTheme = (typeof TileThemes)[keyof typeof TileThemes];

export default TileThemes;
